import React, { useEffect } from "react";
import useAdminDataStore, { selectCurrentGroupData } from "../../store/adminData/adminData";
import useThemeStore, { selectTheme } from "../../store/theme/theme";
import { darkenRGBColor, lightenRGBColor } from "../../utils/colors";

const ThemeProvider = ({ children }) => {
  const theme = useThemeStore(selectTheme);
  const adminData = useAdminDataStore(selectCurrentGroupData);
  const setThemeColors = useThemeStore((state) => state.setThemeColors);

  // const isLightColor = ({ r, g, b }) => {
  //   // Ensure values are valid numbers
  //   const red = parseInt(r) || 0;
  //   const green = parseInt(g) || 0;
  //   const blue = parseInt(b) || 0;

  //   // Calculate relative luminance using WCAG formula
  //   const luminance = 0.2126 * red + 0.7152 * green + 0.0722 * blue;

  //   // Use standard threshold of 128 (0.5 in normalized values)
  //   return luminance > 128;
  // };

  useEffect(() => {
    let primaryColor = adminData?.configuration?.primaryColor;
    let secondaryColor = adminData?.configuration?.secondaryColor;

    let themeColors = {};

    if (primaryColor) {
      const { r, g, b, a } = primaryColor;

      // const primaryTextColor = isLightColor(r, g, b)
      //   ? "rgb(0, 0, 0)"
      //   : "rgb(255, 255, 255)";

      const primaryTextColor = "rgb(255, 255, 255)";

      themeColors = {
        "primary-background": `rgba(${r}, ${g}, ${b}, ${a || 1})`,
        "primary-background-dark": darkenRGBColor(
          {
            r,
            g,
            b,
          },
          0.15
        ),
        "primary-background-darker": darkenRGBColor(
          {
            r,
            g,
            b,
          },
          0.2
        ),
        "primary-background-light": lightenRGBColor(
          {
            r,
            g,
            b,
          },
          0.9
        ),
        "primary-text-color": primaryTextColor,
        "secondary-background": `rgba(${secondaryColor?.r}, ${secondaryColor?.g}, ${secondaryColor?.b}, ${secondaryColor?.a || 0})`,
      };
    }

    if (secondaryColor) {
      const { r, g, b, a } = secondaryColor;

      themeColors["secondary-background"] = `rgba(${r}, ${g}, ${b}, ${a})`;
    }

    setThemeColors(themeColors);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminData?.configuration?.primaryColor]);

  useEffect(() => {
    // Update CSS variables when theme changes
    Object.entries(theme).forEach(([key, value]) => {
      document.documentElement.style.setProperty(`--${key}`, value);
    });
  }, [theme]);

  return <>{children}</>;
};

export default ThemeProvider;
